export const PolicyTypes = {
  General: 'general',
  Auto: 'auto',
  UmbrellaExcess: 'umbrella_excess',
  WorkersComp: 'workers_comp',
  PhysicalDamage: 'physical_damage',
  ProfessionalLiability: 'professional_liability',
  PollutionLiability: 'pollution_liability',
  Cyber: 'cyber',
  Crime: 'crime',
  AdditionalExcessLiability: 'additional_excess_liability',
  Bonds: 'bonds',
  GarageKeepers: 'garage_keepers',
  TechnologyErrorsAndOmissions: 'technology_errors_and_omissions'
};

export const PolicyTypesSelectOptions = [
  {
    value: PolicyTypes.General,
    text: 'General Liability'
  },
  {
    value: PolicyTypes.Auto,
    text: 'Automobile Liability'
  },
  {
    value: PolicyTypes.UmbrellaExcess,
    text: 'Umbrella / Excess Liability'
  },
  {
    value: PolicyTypes.WorkersComp,
    text: 'Workers Comp & Employers\' Liability'
  },
  {
    value: PolicyTypes.PhysicalDamage,
    text: 'Physical Damage'
  }
];

export const AdditionalPolicyTypeNames = [
  PolicyTypes.General,
  PolicyTypes.Auto,
  PolicyTypes.WorkersComp,
  PolicyTypes.UmbrellaExcess,
  PolicyTypes.ProfessionalLiability,
  PolicyTypes.PollutionLiability,
  PolicyTypes.Cyber,
  PolicyTypes.Crime,
  PolicyTypes.AdditionalExcessLiability,
  PolicyTypes.GarageKeepers,
  PolicyTypes.TechnologyErrorsAndOmissions
];
